import {useNavigate} from 'react-router-dom';
import {Guidebook} from '@chekin/core';
import {usePath} from 'hooks';
import {PATHS} from 'routes/constants';

function useGuidebookNavigate(mainPath: string, readerBase = '') {
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const readerPrefix = readerBase ? `${readerBase}/` : '';

  const contentTypeResolver: Record<
    NonNullable<Guidebook['content_type']>,
    (id: string) => string
  > = {
    HTML: id => `${readerPrefix}${PATHS.guidebookHtml}/${id}`,
    PDF: id => `${readerPrefix}${PATHS.guidebookPdf}/${id}`,
    EDITOR: id => `${mainPath}/${id}`,
  };

  const navigateToGuidebook = (guidebook: Guidebook, id: string) => {
    const resolver = guidebook.content_type
      ? contentTypeResolver[guidebook.content_type]
      : (id: string) => `${mainPath}/${id}`;
    navigate(getFullPath(resolver(id)));
  };

  return {navigateToGuidebook};
}

export {useGuidebookNavigate};
